import React, { useEffect, useState } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import { calculateDimension, generateCanvas } from '../../../../Helpers/Chat/canvasImg';
import Spinner from '../../Common/Spinner/index';

const CanvasImage = React.memo(({ uniqueId, imgSrc, generateThumb }) => {
    const canvasId = `${uniqueId}_media_preview_canvas`;

    const [canvasDrawDimension, setCanvasDrawDimension] = useState({ width: 0, height: 0 });
    const [canvasDimension, setCanvasDimension] = useState({ width: 0, height: 0 });
    const [imgDimension, setImgDimension] = useState({ width: 0, height: 0 });
    const [imgObj, setImgObj] = useState(null);

    // Reload whenever the source URL changes (e.g. after crop/rotate).
    useEffect(() => {
        setImgObj(null);
        setImgDimension({ width: 0, height: 0 });
        setCanvasDimension({ width: 0, height: 0 });
        setCanvasDrawDimension({ width: 0, height: 0 });

        const img = document.createElement('img');
        img.src = imgSrc;
        img.onload = () => {
            setImgObj(img);
            setImgDimension({ width: img.width, height: img.height });
        };
    }, [imgSrc]);

    // Draw the canvas once dimensions are ready.
    useEffect(() => {
        if (
            imgObj &&
            canvasId &&
            canvasDimension.width &&
            canvasDimension.height &&
            canvasDrawDimension.width &&
            canvasDrawDimension.height
        ) {
            generateCanvas({ img: imgObj, canvasId, canvasDimension, canvasDrawDimension });
        }
    }, [canvasDrawDimension.width, canvasDrawDimension.height]);

    // Compute canvas dimensions once the image is known, with a rAF retry in
    // case the carousel wrapper hasn't settled its layout yet on the first call.
    useEffect(() => {
        if (!imgDimension.width) return;

        const applyDimensions = dimensions => {
            setCanvasDimension(dimensions.canvasDimension);
            setCanvasDrawDimension(dimensions.canvasDrawDimension);
        };

        const tryCalculate = () => {
            const dimensions = calculateDimension(`${uniqueId}_imageZoomWrapper`, imgDimension);
            if (dimensions) {
                applyDimensions(dimensions);
            } else {
                requestAnimationFrame(() => {
                    const retried = calculateDimension(`${uniqueId}_imageZoomWrapper`, imgDimension);
                    if (retried) applyDimensions(retried);
                });
            }
        };

        tryCalculate();
        if (generateThumb) generateThumb();

        const onResize = () => tryCalculate();
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, [imgDimension.width]);

    return (
        <div className="imageZoomWrapper" id={`${uniqueId}_imageZoomWrapper`}>
            {!canvasDrawDimension.width && !canvasDrawDimension.height && <Spinner />}
            <TransformWrapper>
                {() => (
                    <React.Fragment>
                        <TransformComponent>
                            <canvas
                                className="canvas"
                                id={canvasId}
                                width={canvasDrawDimension.width}
                                height={canvasDrawDimension.height}
                                style={{
                                    width: `${canvasDrawDimension.width}px`,
                                    height: `${canvasDrawDimension.height}px`,
                                }}
                            />
                        </TransformComponent>
                    </React.Fragment>
                )}
            </TransformWrapper>
        </div>
    );
});

export default CanvasImage;
